import React from 'react';

const Library = (props) => {
  return (
    <React.Fragment>
      {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30px" height="30px">
                <path fill={props.color} d="M 12 2.9824219 L 3 6.3027344 L 3 9 L 5 9 L 5 17 L 7 17 L 7 9 L 11 9 L 11 17 L 13 17 L 13 9 L 17 9 L 17 17 L 19 17 L 19 9 L 21 9 L 21 8 L 21 6.3027344 L 12 2.9824219 z M 12 5.1132812 L 17.111328 7 L 6.8886719 7 L 12 5.1132812 z M 3 19 L 3 21 L 21 21 L 21 19 L 3 19 z" /></svg> */}

      <svg
        width="28"
        height="28"
        viewBox="0 0 41 41"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.2955 2.4469H27.4457C27.8828 2.4469 28.2181 2.4469 28.512 2.47457C30.5995 2.67567 32.3082 3.90438 33.0336 5.55926H8.70766C9.43299 3.90438 11.1418 2.67567 13.2292 2.47457C13.5193 2.4469 13.8547 2.4469 14.2955 2.4469ZM10.1508 7.47058C7.53206 7.47058 5.38433 9.02031 4.66842 11.0755L4.6232 11.2047C5.37302 10.9833 6.15487 10.8357 6.94426 10.7379C8.97895 10.4815 11.5525 10.4815 14.5405 10.4815H27.5248C30.5128 10.4815 33.0844 10.4815 35.121 10.7379C35.9123 10.8375 36.6922 10.9814 37.4421 11.2047L37.3987 11.0755C36.6828 9.02031 34.5351 7.47058 31.9145 7.47058H10.1508Z"
          fill="#388AD2"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.6008 12.6714H27.1405C33.4971 12.6714 36.6772 12.6714 38.4632 14.4923C40.2492 16.3132 39.8272 19.1249 38.987 24.75L38.1919 30.0855C37.5325 34.4966 37.2028 36.7032 35.5129 38.0241C33.823 39.3451 31.3305 39.3451 26.3436 39.3451H15.3977C10.4127 39.3451 7.91831 39.3451 6.22838 38.0241C4.53845 36.7032 4.20876 34.4966 3.54937 30.0855L2.75433 24.7518C1.91219 19.1249 1.49206 16.3132 3.27807 14.4923C5.06408 12.6714 8.24424 12.6714 14.6008 12.6714ZM13.3347 31.9654C13.3347 31.2016 14.0375 30.5818 14.9041 30.5818H26.8372C27.7038 30.5818 28.4065 31.2016 28.4065 31.9654C28.4065 32.7292 27.7038 33.3491 26.8372 33.3491H14.9041C14.0375 33.3491 13.3347 32.7292 13.3347 31.9654Z"
          fill="#2C2C2C"
        />
      </svg>
    </React.Fragment>
  );
};
export default Library;
